// ABOUTME: Shared constants for resolving the dashboard view from properties.
// ABOUTME: Used by HomepageRedirect and the sidebar navigation.

export const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const FALLBACK_VIEW_NAME = "mission-control-dashboard";

export const DASHBOARD_VIEW_PROPERTY = "defaults.dashboard_view";
